import { render, staticRenderFns } from "./PresetTextArea.vue?vue&type=template&id=24da8242&scoped=true"
import script from "./PresetTextArea.vue?vue&type=script&lang=js"
export * from "./PresetTextArea.vue?vue&type=script&lang=js"
import style0 from "./PresetTextArea.vue?vue&type=style&index=0&id=24da8242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da8242",
  null
  
)

export default component.exports